import { Box, Divider, Flex, Stack, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';
import { UserProfile } from '../../FSD/pages/users/ui/UserProfile/UserProfile';
import { UserTabs } from '../../FSD/pages/users/ui/UserTabs';
import { Sidebar } from '../../FSD/shared/ui/sidebar/Sidebar';
import useUserId from '../../hooks/urlQueryString/useUserId';

import useHandleDormantUser from '../../hooks/useHandleDormantUser';

type Props = {
  children: ReactNode;
  isInstructor: boolean;
  isInactive: boolean;
  asideChildren?: ReactNode;
  hasUserInfo?: boolean;
};

export default function Layout({ children, isInactive, hasUserInfo = true }: Props) {
  useHandleDormantUser(isInactive);
  const { targetUserId } = useUserId();
  const router = useRouter();
  const pathUserId = router.query.id;
  const isMe = Number(pathUserId) === targetUserId;

  return (
    <Flex
      maw={1200}
      m="0 auto"
      css={{
        justifyContent: isMe ? 'space-between' : 'center',
        padding: '32px',
        [desktopFirstMediaQuery.tablet]: {
          padding: '20px 32px',
        },
        [desktopFirstMediaQuery.mobile]: {
          padding: '20px 16px',
        },
      }}
    >
      {isMe && (
        <Sidebar
          styles={{
            root: {
              minWidth: 190,
              [desktopFirstMediaQuery.tablet]: {
                display: 'none',
              },
            },
          }}
        />
      )}
      <Box
        css={{
          paddingLeft: isMe ? 56 : 0,
          maxWidth: isMe ? '100%' : '890px',
          flex: 1,
          minWidth: 0,

          [desktopFirstMediaQuery.tablet]: {
            paddingLeft: 0,
          },
        }}
      >
        {hasUserInfo && (
          <>
            <Stack spacing={24}>
              <UserProfile />
              <UserTabs />
            </Stack>
            <Divider size={8} color="gray.0" />
          </>
        )}
        <Box>{children}</Box>
      </Box>
    </Flex>
  );
}
